import * as Mtds from '@mattilsynet/design/react'
import { ArrowSquareOutIcon } from '@phosphor-icons/react/ssr'
import type { PlanLegislation } from '../../types/types'
import { legislationReferences, lovdataUrl } from '../../utils/legislationLinks'
import styles from './LegislationReferences.module.css'

type LegislationReferencesProps = {
  entry: Pick<PlanLegislation, 'legislation' | 'selectedParts'>
}

export function LegislationReferences({
  entry
}: Readonly<LegislationReferencesProps>) {
  const selectedReferences = legislationReferences(
    entry.legislation.documentId,
    entry.selectedParts
  )
  const needsDocumentFallback =
    selectedReferences.length > 0 &&
    selectedReferences.every((reference) => !reference.href)

  const references =
    selectedReferences.length > 0
      ? selectedReferences
      : [
          {
            id: 'document',
            label: 'Hele regelverket',
            href: lovdataUrl(entry.legislation.documentId)
          }
        ]

  return (
    <Mtds.Prose className={styles.references}>
      <ul aria-label='Valgte hjemler'>
        {references.map((reference) => (
          <li key={reference.id}>
            {reference.href ? (
              <Mtds.Link
                href={reference.href}
                target='_blank'
                rel='noopener noreferrer'
                aria-label={`${reference.label} – ${entry.legislation.shortTitle}, gjeldende tekst på Lovdata (åpnes i ny fane)`}
                className={styles.referenceLink}
              >
                {reference.label} <ArrowSquareOutIcon aria-hidden />
              </Mtds.Link>
            ) : (
              <p>{reference.label}</p>
            )}
          </li>
        ))}
      </ul>
      {needsDocumentFallback && (
        <Mtds.Link
          href={lovdataUrl(entry.legislation.documentId)}
          target='_blank'
          rel='noopener noreferrer'
          aria-label={`Se hele regelverket – ${entry.legislation.shortTitle} på Lovdata (åpnes i ny fane)`}
          className={styles.referenceLink}
        >
          Se hele regelverket <ArrowSquareOutIcon aria-hidden />
        </Mtds.Link>
      )}
    </Mtds.Prose>
  )
}
